const langtrans={
      jlhgzz:["建立合作","To establish cooperation"],
      gsmccc:["公司名称","Company name"],
      srgsmc:["输入公司名称","Please enter the company's name"],
      gswzhj:["公司网站或简介","Company website or profile"],
      srgswz:["输入公司网站或者简介","Please enter the company website or profile"],
      lxjrxm:["联系人姓名","Name of contact person"],
      srgslx:["输入公司联系人","Please enter the name of contact person"],
      lxjfs:["联系方式","Contact information"],
      srlxjr:["输入联系人电话","Please enter the phone number of the contact person"],
      hgzzzy:["合作意向","Cooperation intention"],
      srnddd:["输入您的合作意向","Please enter your cooperation intention"],
      tdsjxs:["提交信息","To Submit the Informaton"],
      tdsjcg:["提交成功","Submit successfully"],
      qsrlxj:["请输入联系人方式","Please enter the name of contact person"],
      qsrgsm:["请输入公司名称","Please enter the company's name"],
      jyjgdl:["救援机构登录成功","Your login Assistance organization is successful"],
      jjgjgd:["监管机构登录成功","en_translated"],
      zzzhzz:["指挥中心登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","Your login failed for incorrect user name or password"],
      dlsbwz:["登录失败，未知错误","Your login failed for unknown reason"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/jlhz.vue.trans.js